import type { ListBuilderList } from '../../../types';
import {
	AGING_REQUIRED_FIELDS,
	BASE_FILTER_RULES,
	INVOICE_MOBILE_CARD_CONFIG,
} from '../shared';

/**
 * Past due 31-60 days - outstanding invoices 31 to 60 days past due
 */
export const pastDue31To60List: ListBuilderList = {
	id: 'default-invoices-past-due-31-60',
	inheritsFrom: 'default-invoices-all',
	cacheTTL: 600000,
	name: 'Past Due 31-60',
	type: 'default',
	active: true,
	sortOrder: 4,
	description: 'Outstanding invoices 31 to 60 days past due',
	defaultSortId: 'date-asc',
	requiredFields: AGING_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		invoicePaymentStatus: {
			defaultValue: [{ id: 'outstanding', label: 'Outstanding' }],
		},
		invoiceDueDateRange: {
			defaultValue: [
				{
					id: 'past-due-31-60',
					label: '31-60 Days Past Due',
					data: {
						startDate: '{{DATE:-60d}}',
						endDate: '{{DATE:-31d}}',
					},
				},
			],
		},
		// Clear the default 90-day invoice date filter so all matching invoices show
		invoiceDateRange: {
			defaultValue: [],
		},
	},
	mobileCardConfig: INVOICE_MOBILE_CARD_CONFIG,
};
